import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/8 bg-obsidian-800 mt-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
      <div className="md:col-span-2">
        <div className="flex items-center gap-2 mb-4">
          <span className="font-mono text-[0.7rem] tracking-[0.35em] text-amber-glow">SCOTT</span>
          <span className="font-serif text-2xl">Burton Photography</span>
        </div>
        <p className="text-neutral-400 text-sm max-w-sm leading-relaxed">
          Weddings, sports and photojournalism from Oxford, Mississippi. Twenty years and over two
          thousand weddings behind the lens — published in Sports Illustrated, Newsweek and ESPN.
          Explore the portfolio, license a time-lapse, or order a fine-art print of any frame.
        </p>
        <div className="flex gap-4 mt-6 text-neutral-400">
          <a href="https://www.instagram.com/scottburtonphotography/" target="_blank" rel="noreferrer" className="hover:text-amber-glow transition-colors"><Instagram size={18} /></a>
          <a href="https://www.facebook.com/scottburtonphotography" target="_blank" rel="noreferrer" className="hover:text-amber-glow transition-colors"><Facebook size={18} /></a>
          <a href="tel:6628013526" className="hover:text-amber-glow transition-colors text-sm font-mono self-center">662.801.3526</a>
        </div>
      </div>
      <div>
        <div className="overline-label mb-4">Explore</div>
        <ul className="space-y-2 text-sm text-neutral-300">
          <li><Link to="/portfolio" className="hover:text-amber-glow">Portfolio</Link></li>
          <li><Link to="/shop" className="hover:text-amber-glow">Shop Prints</Link></li>
          <li><Link to="/gallery" className="hover:text-amber-glow">Time-Lapses</Link></li>
          <li><Link to="/collections/hurricane-helene" className="hover:text-amber-glow">Hurricane Helene</Link></li>
        </ul>
      </div>
      <div>
        <div className="overline-label mb-4">Studio</div>
        <ul className="space-y-2 text-sm text-neutral-300">
          <li><Link to="/about" className="hover:text-amber-glow">About</Link></li>
          <li><Link to="/contact" className="hover:text-amber-glow">Contact</Link></li>
          <li><Link to="/planners" data-testid="footer-planners-link" className="hover:text-amber-glow">For Planners &amp; Venues</Link></li>
          <li><Link to="/account" className="hover:text-amber-glow">Order Status</Link></li>
          <li><Link to="/privacy" className="hover:text-amber-glow">Privacy</Link></li>
          <li><Link to="/terms" className="hover:text-amber-glow">Terms &amp; Prints</Link></li>
          <li><Link to="/admin" className="hover:text-amber-glow">Studio Admin</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/8 py-6 text-center text-xs text-neutral-500">
      © {new Date().getFullYear()} Scott Burton Photography · Oxford, Mississippi. All rights reserved. Prints by Miller's Professional Imaging.
    </div>
  </footer>
);
